<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5" v-if="$route.name == 'trx-non-order-all'">Data Transaksi Non Order Warehouse</div>
			<div class="text-h5" v-else>Data Transaksi Non Order</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link class="text-deco" :to="{ name: 'add-trx-non-order' }" v-if="hasAccess('add-trx-non-order')">
							<v-btn light depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Data</div>
							</v-btn>
						</router-link>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<v-col cols="12" class="px-4">
						<v-row>
							<v-col cols="12" md="3" >
								<v-text-field outlined dense hide-details label="Kode" v-model="non_order_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(nonOrderDate)" label="Tanggal" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="nonOrderDate"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-autocomplete :items="status_list" label="Status" item-text="status" item-value="code" v-model="non_order_status.value" no-data-text="Tidak ada data yang sesuai" class="details-mb-0 text-capitalize" outlined dense hide-details="auto" background-color="white"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete :items="nonOrderType" label="Jenis" v-model="non_order_type.value" no-data-text="Tidak ada data yang sesuai" class="details-mb-0 text-capitalize" outlined dense hide-details="auto" background-color="white">
									<template v-slot:item="{ item }">
										<span class="text-capitalize">{{item}}</span>
									</template>
									<template v-slot:selection="{ item }">
										<span class="text-capitalize">{{item}}</span>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete :items="listWarehouse" label="Warehouse" v-model="non_order_warehouse.value" no-data-text="Tidak ada data yang sesuai" class="details-mb-0 text-capitalize" outlined dense hide-details="auto" background-color="white" item-text="warehouse_name" item-value="warehouse_id" v-if="$route.name == 'trx-non-order-all'">
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="9" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<div>
				<v-card outlined v-if="listNonOrder.length == 0 && nonOrderPagination">
					<div class="py-3">
						<not-found></not-found>
					</div>
				</v-card>
				<v-card class="mb-3" outlined v-for="nonOrder in listNonOrder" :key="nonOrder.product_stock_trx_non_order_code">
					<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Transaksi {{ nonOrder.product_stock_trx_non_order_code }}
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Tanggal Transaksi</div>
									<div class="subtitle-2">{{ nonOrder.product_stock_trx_non_order_created_datetime | tanggal }}</div>
								</v-flex>
								<v-flex xs6 sm2 md2 class="pl-4">
									<div class="body-2 oppacity-75">Warehouse</div>
									<div class="subtitle-2 text-capitalize">{{ nonOrder.warehouse_name }}</div>
								</v-flex>
								<v-flex xs12 sm4 md4 class="pl-4">
									<div class="body-2 oppacity-75">Catatan</div>
									<div class="subtitle-2">{{ nonOrder.product_stock_trx_non_order_note }}</div>
								</v-flex>
								<v-flex xs12 sm3 md3 class="pl-4">
									<div class="body-2 oppacity-75">Status</div>
									<div class="subtitle-2">{{ nonOrder.product_stock_trx_non_order_status | toNonOrderStatus }}</div>
								</v-flex>
							</v-layout>
						</v-list-item-content>
					</v-list-item>
					<div class="pt-3">
						<v-card tile elevation="0">
							<v-data-table :headers="headersProduct" :items="nonOrder.product_stock_trx_non_order_detail" :items-per-page="1000" class="elevation-0" hide-default-footer>
								<template v-slot:item.product_stock_trx_non_order_detail_quantity="{ item }">
									<div>{{ item.product_stock_trx_non_order_detail_quantity | toNumber }}</div>
								</template>
							</v-data-table>
						</v-card>
					</div>
				</v-card>
			</div>
			<div class="pt-5">
				<v-row v-if="nonOrderPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="nonOrderPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState } from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			nonOrderType: ['compliment', 'officer check'],
			nonOrderStatus: ['created', 'approved', 'canceled'],
			menu: false,
			loading: true,
			type: '',
			headersProduct: [
			{ text: 'Nama Produk', value: 'product_stock_trx_non_order_detail_product_name', sortable: false, width: '50%' },
			{ text: 'Kode Produk', value: 'product_stock_trx_non_order_detail_product_code' },
			{ text: 'Unit Produk', value: 'product_stock_trx_non_order_detail_product_unit' },
			{ text: 'Jumlah', value: 'product_stock_trx_non_order_detail_quantity', align: 'center'},
			],
			non_order_code: {
				value: '',
				comparison: 'like',
				type: 'string',
				field: 'product_stock_trx_non_order_code'
			},
			non_order_type: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'product_stock_trx_non_order_type'
			},
			non_order_warehouse: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'product_stock_trx_non_order_warehouse_id'
			},
			non_order_status: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'product_stock_trx_non_order_status'
			},
			non_order_date: {
				value: '',
				comparison: 'bet',
				type: 'date',
				field: 'product_stock_trx_non_order_created_datetime'
			},
			nonOrderDate: [],
			sortBy: 'product_stock_trx_non_order_id',
			sortDir: 'DESC',
			page: 1,
			limit: 10,
			listLimit: [ 5, 10, 20, 50, 100 ],
			dropfilter: false,
			dialog: false,
			dialogConfirm: false,
			params:[],
			procces_po_id: '',
			poProccess : '',
		}
	},
	computed: {
		...mapState('nonOrder', ['listNonOrder', 'detailNonOrder', 'nonOrderPagination', 'listWarehouse']),

		status_list() {
			return this.nonOrderStatus.map( (el) => {
				return {
					code: el,
					status: this.$options.filters.toNonOrderStatus(el)
				}
			})
		}
	},
	methods: {
		...mapActions('nonOrder', ['getNonOrder', 'getNonOrderAll', 'getDetailNonOrder', 'exportNonOrder', 'exportNonOrderAll', 'getOptionWarehouse']),

		exportData(){
			if (this.$route.name == 'trx-non-order-all') {
				this.exportNonOrderAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			} else {
				this.exportNonOrder(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		getData() {
			if (this.$route.name == 'trx-non-order-all') {
				this.getNonOrderAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					this.loading = false
				})
			} else {
				this.getNonOrder(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					this.loading = false
				})
			}
		},
		resetFilter(){
			this.non_order_code.value = ''
			this.non_order_date.value = ''
			this.non_order_type.value = ''
			this.non_order_warehouse.value = ''
			this.non_order_status.value = ''
			this.nonOrderDate = []
			this.page = 1
			this.getData()
		},
		cari(){
			this.params = []
			if (this.non_order_code.value)
				this.params.push(this.non_order_code)
			if (this.non_order_type.value)
				this.params.push(this.non_order_type)
			if (this.non_order_warehouse.value)
				this.params.push(this.non_order_warehouse)
			if (this.non_order_status.value)
				this.params.push(this.non_order_status)
			if (this.non_order_date.value){
				if (this.non_order_date.value.length > 1) {
					this.non_order_date.value.sort()
					let date = this.non_order_date.value.join('::')
					this.non_order_date.value = date
				}
				this.params.push(Object.assign({}, this.non_order_date))
			}
			this.page = 1
			this.getData()
		},
		changePage(page){
			this.page = page
			this.getData()
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Transaksi Non Order`)
		this.getData()
		this.getOptionWarehouse()
	},
	watch: {
		nonOrderDate(val) {
			this.non_order_date.value = val
		},
		limit() {
			this.page = 1
			this.getData()
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		},
		$route(val) {
			if (val.name == 'trx-non-order-all' || val.name == 'trx-non-order' ) {
				this.getData()
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>